import Domain from 'helpers/Domain';
import SummaryComponent from 'aa/vue/components/Summary';
import Step from 'models/steps/Step';
import {
    handleProcessedPayment,
    handleProcessedPaymentError,
    redirectLinkToSubmitPayment,
} from 'aa/vue/components/payment/signupUtil';
import { CAMPAIGN_SERVICE_ENABLED, SKIP_EXPLAINER_STEPS } from 'aa/helpers/featureConstants';
import { AA_PACKAGE_SWITCH } from 'helpers/featureConstants';
import { getSelectedPlanFromSession } from 'aa/vue/routers/AccountRouter.helpers';

export default class Summary extends Step {
    path = '/account/signup/summary/';
    name = 'PAYMENT_SUMMARY';
    requireAuth = true;
    requireNonAuth = false;
    countStep = true;
    props = {
        handleProcessedPayment,
        handleProcessedPaymentError,
    };

    constructor() {
        super();
        this.component = SummaryComponent;
    }

    async beforeEnter(to, from, next) {
        // Important for if user backs out of paying for one plan and chooses another
        this._store.commit('setAutoPromoChecked', false);

        if (CBS.Registry.Features[CAMPAIGN_SERVICE_ENABLED]) {
            this._store.commit('setCampaignOfferCoupon');
        }

        return super.beforeEnter(to, from, next);
    }

    enterRoute(to, from, next) {
        this.getPageAttributes(to, from);

        next();
    }

    /**
     * @param to
     * @returns {{path: *, name: *}}
     */
    getTrackingArgs(to) {
        let args = super.getTrackingArgs(to);
        let productParams = this._store.getters['getPaymentPageProductParamsForTracking'];

        args.pageTitle = 'Paramount+ Payment Information - ParamountPlus.com';
        args.pageType = 'svod_payment';
        args.pageName = this.path;
        args.userType = this._store.state.user.svod.status;

        args.purchaseProduct = productParams.recurlyCode;
        args.purchaseQuantity = '1';
        args.purchaseCategory = productParams.purchaseCategory;
        args.purchasePrice = this._store.getters.bundleShowtime
            ? productParams.showtimeBundleRawPrice()
            : productParams.purchasePrice;
        args.productPricingPlan = productParams.planType ?? productParams.productPricingPlan;
        args.productOfferPeriod = productParams.trialString ?? '';

        if (this.plan) {
            if (typeof this.plan.planTier !== 'undefined') {
                args.pickPlanType = this.plan.planTier;
                args.pickPlanSku = this.plan.recurlyCode;
            }

            //assumption: productParams (set for US) may have tracking vars
            //not needed for INTL
            const dynamicPlan = Domain.isInternational() ? this.plan : productParams;
            args = {
                ...args,
                purchaseEventBillingStart: '1',
                productOfferPeriod: this.plan.purchaseOfferPeriod || args.productOfferPeriod,
                purchasePrice: dynamicPlan.rawPrice || args.purchasePrice,
                productPricingPlan: this.plan.planType || args.productPricingPlan,
                purchaseProduct: this.plan.recurlyCode,
                purchaseProductName: dynamicPlan.titleForTracking,
            };
        }
        return args;
    }

    async checkFlowRedirect(from = null) {
        if (
            Domain.isDomestic() &&
            this._store.getters.featureIsActive(AA_PACKAGE_SWITCH) &&
            !this._store.getters['flow/skipPlan']
        ) {
            const selectedPlan = getSelectedPlanFromSession();

            if (!selectedPlan) {
                if (this._store.getters.featureIsActive(SKIP_EXPLAINER_STEPS)) {
                    return { name: 'PLAN' };
                }
                return { name: 'plan_explainer' };
            }

            this._store.dispatch('plan/updateSelectedPlan', selectedPlan);
        }

        if (this._store.getters['flow/isEdu']) {
            if (this._store.getters['user/eduCoupon']) {
                this._store.commit('setPromo', this._store.getters['user/eduCoupon']);
            } else {
                return {
                    path: this._store.getters['flow/getFirstStepForAuth'].path,
                };
            }
        } else if (this._store.getters['flow/isGift'] && !this._store.state.user.isLoggedIn) {
            return {
                path: { name: 'SIGNUP' },
            };
        }

        const shouldRedirectToSubmitPayment = await redirectLinkToSubmitPayment(this._store);
        if (shouldRedirectToSubmitPayment) {
            return shouldRedirectToSubmitPayment;
        }

        return null;
    }
}
